import { getLink, trans } from "~/providers/lang";
import { Link } from "react-router-dom";
import { ROUTES } from '~/const';
import { useSeo } from "~/hooks/useSeo";

import "./style.less";

export default function ContactsPage() {
	useSeo({
		title: trans("skelet.title.contacts"),
		canonical: "kontakty",
	});

	return <div className="body-background">
		<div className="contacts-page page-content">
			<h1 className="other-page-title">
				{trans('contacts.title')}
			</h1>
			<div className="row">
				<div className="col-md-4">
					<h2>
						{trans('contacts.person.title')}
					</h2>
					<p className="desc" dangerouslySetInnerHTML={{ __html: trans('contacts.person.desc') }} />
				</div>
				<div className="col-md-4">
					<h2>
						{trans('contacts.visit.title')}
					</h2>
					<p className="desc" dangerouslySetInnerHTML={{ __html: trans('contacts.visit.desc') }} />
				</div>
				<div className="col-md-4">
					<h2>
						{trans('contacts.shop.title')}
					</h2>
					<Link to={getLink(ROUTES.galleryShop)} className="gallery-link">
						<img src="/galerie-satu/prodejna/prodejna-s-01.jpg" alt={trans('contacts.shop.alt')} className="with-border click" />
					</Link>
				</div>
			</div>
			<div className="row">
				<div className="col-md-12" style={{ marginTop: "25px" }}>
					<h3>
						{trans('contacts.findus')}
					</h3>
					<div className="map">
						<iframe width="100%" height="600" src="https://frame.mapy.cz/zakladni?x=17.1289596881&amp;y=48.8520099713&amp;z=17&amp;source=firm&amp;id=449183&amp;widgetFirmy=449183" style={{ border: "none" }} frameBorder="0"></iframe>
					</div>
				</div>
			</div>
		</div>
	</div>;
}
